import { PropsWithChildren, ReactElement, MouseEvent, RefObject } from 'react';
import { twMerge } from 'tailwind-merge';
import {
  ButtonStyleSubVariant,
  buttonStylesVariants,
  ButtonStyleVariant,
} from './styles';

interface ButtonProps {
  className?: string;
  variant?: ButtonStyleVariant;
  subVariant?: ButtonStyleSubVariant;
  buttonRef?: RefObject<HTMLButtonElement>;
  isDisabled?: boolean;
  disablePadding?: boolean;
  buttonType?: 'submit' | 'reset' | 'button' | undefined;
  onClick?: (e: MouseEvent) => void;
}

export const Button = ({
  className,
  disablePadding,
  buttonRef,
  onClick,
  variant = 'primary',
  subVariant,
  children,
  buttonType = 'button',
  isDisabled,
}: PropsWithChildren<ButtonProps>): ReactElement => (
  <button
    ref={buttonRef}
    disabled={isDisabled}
    type={buttonType}
    className={twMerge(
      'flex w-fit items-center justify-center rounded-md p-2.5 text-center text-sm font-black transition-shadow duration-300 hover:shadow-custom',
      buttonStylesVariants(variant, subVariant, isDisabled),
      disablePadding && 'p-0',
      className,
    )}
    onClick={onClick}
  >
    {children}
  </button>
);
